import { AdsPage } from 'pages/ads/AdsPage';
import { BooksPage } from 'pages/books/BooksPage';
import { ChessPage } from 'pages/chess/ChessPage';
import { CinemaPage } from 'pages/cinema/CinemaPage';
import { CoursesPage } from 'pages/course/CoursePage';
import { EventsPage } from 'pages/event/EventPage';
import { HomePage } from 'pages/home/HomePage';
import { NewsPage } from 'pages/news/NewsPage';
import { PoetryPage } from 'pages/poetry/PoetryPage';
import { AboutUsPage } from 'pages/aboutUs/AboutUsPage';
import { SingleAdsPage } from 'pages/singleAds';
import { SingleBookPage } from 'pages/singleBooks';
import { SingleChessPage } from 'pages/singleChess';
import { SingleCinemaPage } from 'pages/singleCinema';
import { SingleCoursePage } from 'pages/singleCourse';
import { SingleEventPage } from 'pages/singleEvent';
import { SingleNewsPage } from 'pages/singleNews';
import { SinglePoetryPage } from 'pages/singlePoetry';

export const AllRoutes = [
    {
        path: '/',
        element: <HomePage />
    },
    {
        path: '/news',
        element: <NewsPage />
    },
    {
        path: '/news/:id',
        element: <SingleNewsPage />
    },
    {
        path: '/ads',
        element: <AdsPage />
    },
    {
        path: '/ads/:id',
        element: <SingleAdsPage />
    },
    {
        path: '/cinema-club',
        element: <CinemaPage />
    },
    {
        path: '/cinema-club/:id',
        element: <SingleCinemaPage />
    },
    {
        path: '/book-club',
        element: <BooksPage />
    },
    {
        path: '/book-club/:id',
        element: <SingleBookPage />
    },
    {
        path: '/events',
        element: <EventsPage />
    },
    {
        path: '/events/:id',
        element: <SingleEventPage />
    },
    {
        path: '/chess-club',
        element: <ChessPage />
    },
    {
        path: '/chess-club/:id',
        element: <SingleChessPage />
    },
    {
        path: '/poetry-club',
        element: <PoetryPage />
    },
    {
        path: '/poetry-club/:id',
        element: <SinglePoetryPage />
    },
    {
        path: '/courses',
        element: <CoursesPage />
    },
    {
        path: '/courses/:id',
        element: <SingleCoursePage />
    },
    {
        path: '/about-us',
        element: <AboutUsPage />
    },
];
